import {
  DateInput as NextUIDateInput,
  DateInputProps as NextUIDateInputProps,
} from "@heroui/react";
import { CalendarDate, CalendarDateTime } from "@internationalized/date";
import { convertCalendarDateToUnix, toCalendarDate } from "../../utils/date";
import { getDateInputClassNames } from "../../utils/styles";

type Color = Extract<NextUIDateInputProps["color"], "default">;
type LabelPlacement = Extract<
  NextUIDateInputProps["labelPlacement"],
  "outside"
>;
type Variant = Extract<NextUIDateInputProps["variant"], "bordered">;

export type DateInputProps = Omit<
  NextUIDateInputProps,
  "color" | "labelPlacement" | "variant" | "value" | "minValue" | "maxValue"
> & {
  color?: Color;
  labelPlacement?: LabelPlacement;
  maxValue?: number;
  minValue?: number;
  onChange?: (value: number | null) => void;
  value?: number | null;
  variant?: Variant;
};

export function DateInput(props: DateInputProps) {
  const { maxValue, minValue, onChange, value, ...rest } = props;

  const handleChange = (
    calendarDate: CalendarDate | CalendarDateTime | null,
  ) => {
    if (!onChange) return;
    onChange(convertCalendarDateToUnix(calendarDate));
  };

  return (
    <NextUIDateInput
      {...rest}
      value={toCalendarDate(value) as NextUIDateInputProps["value"]}
      minValue={toCalendarDate(minValue)}
      maxValue={toCalendarDate(maxValue)}
      classNames={getDateInputClassNames(props.size)}
      color="default"
      data-testid={props.name}
      labelPlacement="outside"
      variant="bordered"
      onChange={handleChange}
    />
  );
}

DateInput.displayName = "RecareUI.DateInput";
